import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@veneer/core';

import { useDependencyManagerContext } from '../contexts/dependencyManager';
import { TabIndexProvider } from '../contexts/tab-index';
import { getUserCleanup, getUserRequest } from '../features/user/user-slice';
import { initializeCachedCategory } from '../utils/cached-category';
import { RootState } from '../store';
import { OperationStatus } from '../types';

import DeviceDetailsViewer from '../components/device-details-viewer';
import WelcomeMessage from '../components/welcome-message';
import { Container } from './styled';

const Router = () => {
  const {
    northboundAPIs: { v1 }
  } = useDependencyManagerContext();
  const theme = useTheme();
  const dispatch = useDispatch();

  const { user, getUser } = useSelector(
    (state: RootState) => state.UserReducer
  );
  const userEmail = user?.email?.value;

  useEffect(() => {
    if (v1) {
      dispatch(getUserRequest());
    }
    return () => dispatch(getUserCleanup());
  }, [v1, dispatch]);

  useEffect(() => {
    if (getUser.status === OperationStatus.COMPLETED && userEmail) {
      initializeCachedCategory(userEmail);
    }
  }, [getUser.status, userEmail]);

  return (
    <TabIndexProvider startingIndex={1}>
      <Container $veneerTheme={theme}>
        <WelcomeMessage />
        <DeviceDetailsViewer />
      </Container>
    </TabIndexProvider>
  );
};

export default memo(Router);
